export function loadBookingCalendar() {

    if(!document.querySelector('script#nf-booking-calendar')) {
        const s = document.createElement('script');
        // @ts-ignore
        s.src= import.meta.env.VITE_BOOKING_CALENDAR_URL;
        s.async = true;
        s.defer = true;
        s.id = 'nf-booking-calendar';
        document.head.appendChild(s);
    }
}